<template>
  <div class="menu-main-container" v-if="isDesktop">
    <nav class="main-nav">
      <ul class="menu">
        <li
          v-for="(item, index) in menuItems"
          :key="item.id"
          class="menu-item"
          @mouseenter="active = item.id"
          @mouseleave="active = null"
        >
          <NuxtLink v-if="!isExternal(item.href)" :to="item.href">{{
            item.name
          }}</NuxtLink>
          <a v-else :href="item.href" target="_blank">{{ item.name }}</a>

          <div
            class="dropdown-content"
            v-if="item.sub_menu && item.id !== 'new-now'"
            :class="{ active: active === item.id }"
          >
            <div class="full_width">
              <div
                :class="`dc-${item.id}`"
              >
                <ul class="centered">
                  <li v-for="sub in item.sub_menu" :key="sub.id">
                    <NuxtLink
                      v-if="!isExternal(sub.href)"
                      :to="sub.href"
                      @click="active = null"
                      >{{ sub.name }}</NuxtLink
                    >
                    <a
                      v-else
                      :href="sub.href"
                      target="_blank"
                      @click="active = null"
                      >{{ sub.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            class="dropdown-content"
            v-else-if="item.id === 'new-now'"
            :class="{ active: active === item.id }"
          >
            <div class="full_width dc_the_issue">
              <div class="left-container">
                <h2>New + Now</h2>
                <div
                  :class="`dc-${item.id}`"
                >
                  <div class="columns-wrapper">
                    <ul class="left-column centered">
                      <li
                        v-for="sub in (item.sub_menu ?? []).filter(
                          (s) => s.position === 'left'
                        )"
                        :key="sub.id"
                      >
                        <NuxtLink
                          :class="{'red': sub.holiday, 'bold': sub.featured }"
                          v-if="!isExternal(sub.href)"
                          :to="sub.href"
                          @click="active = null"
                          >{{ sub.name }}</NuxtLink
                        >
                        <a
                          v-else
                          :class="{'red': sub.holiday, 'bold': sub.featured }"
                          :href="sub.href"
                          target="_blank"
                          @click="active = null"
                          >{{ sub.name }}</a
                        >
                      </li>
                    </ul>

                    <ul class="right-column centered">
                      <li
                        v-for="sub in (item.sub_menu ?? []).filter(
                          (s) => s.position === 'right'
                        )"
                        :key="sub.id"
                      >
                        <NuxtLink v-if="!isExternal(sub.href)" :to="sub.href" @click="active = null">{{
                          sub.name
                        }}</NuxtLink>
                        <a v-else :href="sub.href" target="_blank" @click="active = null">{{
                          sub.name
                        }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="right-container" v-if="featuredPost">
                <div class="featured-post-wrapper">
                  <NuxtLink
                    :to="`/blog/${featuredPost?.slug}`"
                    class="featured-image"
                    @click="active = null"
                  >
                    <NuxtImg
                      :src="featuredPost?.image_url + '?auto=format,compress&fm=webp'"
                      :alt="featuredPost?.title"
                      class="img-fluid"
                      :modifiers="{ format: 'webp' }" 
                    />
                  </NuxtLink>

                  <div class="featured-content">
                    <div class="category-list">
                      <NuxtLink
                        v-for="(cat, idx) in featuredPost?.categories"
                        :key="idx"
                        @click="active = null"
                        :to="`/category/${cat.slug}`"
                        class="featured-cat"
                      >
                        {{ cat.name }}
                      </NuxtLink>
                    </div>
                    <NuxtLink
                      :to="`/blog/${featuredPost?.slug}`"
                      class="featured-title"
                      @click="active = null"
                    >
                      {{ featuredPost.title }}
                    </NuxtLink>

                    <NuxtLink
                      :to="`/blog/${featuredPost?.slug}`"
                      class="featured-btn"
                      @click="active = null"
                    >
                      Read More
                    </NuxtLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
const { isDesktop } = useMobileChecker();

const active = ref(null);
const props = defineProps(["menuItems", "property"]);

const isExternal = (url) => url.startsWith("http");
const { posts, loadPosts } = useBlogPosts("Main");
const postsRequested = ref(false);

watch(active, (id) => {
  if (id !== "new-now" || postsRequested.value) return;
  postsRequested.value = true;
  loadPosts();
});

const featuredPost = computed(() => {
  return posts.value
    .filter((post) => post.publish_date)
    .sort((a, b) => {
      const dateA = new Date(a.publish_date);
      const dateB = new Date(b.publish_date);
      return dateB - dateA; // descending order
    })[0];
});
</script>

<style scoped lang="scss">
.menu-main-container {
  border-top: 1px solid$black;
  border-bottom: 1px solid$black;
}
.main-nav {
  display: table;
  margin: auto;

  .menu {
    width: fit-content;
    display: inline-block;
    margin: 0;

    .menu-item {
      display: inline-block;
      float: left;
      font-family: $font_poppin_bold;
      font-weight: bold;
      font-size: 13px;
      text-transform: uppercase;
      color: #000;
      line-height: 13px;
      letter-spacing: 1.5px;
      margin: 0;
      padding: 14px 8px 7px;
      z-index: 999999999999999999999999 !important;

      a {
        text-decoration: none;
        padding: 3px 25px !important;

        &:hover {
          color: #a09a98 !important;
        }
      }

      .dropdown-content {
        display: none;
        position: absolute;
        background-color: $white;
        width: 100%;
        z-index: 999;
        left: 0;
        right: 0;
        margin: 13px 0 0 0;
        border-bottom: 1px solid $black;

        .dc-store-directory {
          width: 158px;
          height: auto;
          margin: 0 0 0 35px;
        }

        .dc-about {
          width: 163px;
          height: auto;
          margin: 0 0 0 193px;
        }

        .dc-event-list {
          width: 163px;
          height: auto;
          margin: 0 0 0 340px;
        }

        .dc-guest-services {
          width: 163px;
          height: auto;
          margin: 0 0 0 472px;
        }

        .centered {
          text-align: center !important;
          width: auto !important;
          padding: 0 !important;
          margin: 20px 0 !important;
          list-style: none;

          li {
            display: block !important;
            text-align: center !important;
            margin: 0 !important;
            padding: 0 !important;
            width: 100%;
            text-indent: 0 !important;
            line-height: 12px !important;

            a {
              display: block;
              color: $black;
              height: 100%;
              padding: 0 0 3px 0;
              cursor: pointer;
              margin: 10px 0 !important;
              padding: 0 !important;
            }
          }
        }
      }
    }

    .menu-item:hover {
      transition: all 0.3s ease;
      > .dropdown-content {
        display: block;
        border-top: 1px solid $black;
      }

      > a {
        color: #a09a98;
        border-bottom: 8px solid #000;
        padding: 10px 0 0 0;
        text-decoration: none;
      }
    }

    .full_width {
      width: 1152px !important; 
      // width: 1024px !important; width for when lookbook menu is not a parent menu item
      margin: 0 auto !important;

      &.dc_the_issue {
        max-width: 1125px; // max-width: 1024px;
        display: flex;
        // height: 100px;
        // margin: 0 auto;

        .left-container {
          text-align: left;
          float: left;
          width: 60%;
          margin: 0 0 0 0px;

          h2 {
            font-size: 30px;
            text-transform: uppercase;
            margin: 40px 42px 0 0;
            padding: 0 0 10px 0;
            border-bottom: 1px solid #000;
          }

          .centered {
            text-align: left !important;
            margin: 10px 0 20px !important;
          }

          .columns-wrapper {
            display: flex;
            justify-content: space-between;
            gap: 40px;
            width: 350px;
            margin: 0 0 20px 0 !important;

            .left-column,
            .right-column {
              list-style: none;
              padding: 0;
              margin: 0;
              width: 50%;

              .red {
                color: #cc0000 !important;
              }

              .bold {
                font-family: $font_poppin_bold !important;
              }

              li {
                text-align: left !important;
                // margin-bottom: 10px;
                font-family: $font_poppin_light;
                font-size: 12px !important;
                line-height: 16px !important;
                font-weight: normal !important;
                padding: 0 !important;
                margin: 0 !important;
                clear: left;

                a {
                  display: block;
                  color: #000;
                  text-decoration: none;
                  font-family: $font_poppin_light !important;
                  font-size: 12px !important;
                  line-height: 16px !important;

                  &:hover {
                    text-decoration: underline !important;
                  }
                }
              }
            }
          }
        }

        .right-container {
          width: 40%;
          border-left: 1px solid $black;
          .featured-post-wrapper {
            padding: 40px 50px 10px;

            a {
              color: $black !important;
            }

            .featured-image {
              img {
                // aspect-ratio: 16/ 9 !important;
                width: 80%;
              }
            }

            .featured-content {
              margin: 20px 0;
              display: flex;
              flex-direction: column;

              .featured-cat {
                display: inline-block;
                float: left;
                font-family: $font_poppin_bold;
                font-weight: bold;
                font-size: 13px;
                text-transform: uppercase;
                color: #000;
                line-height: 13px;
                letter-spacing: 1.5px;
              }

              .featured-title {
                font-family: $font_didot_ltd_roman;
                font-style: italic;
                text-transform: uppercase;
                letter-spacing: -1px;
                font-size: 27px;
                line-height: 26px;
                margin: 0 0 15px 0;
                clear: both;
              }

              .featured-btn {
                text-decoration: underline;
                color: $black;
              }
            }
          }
        }
      }
    }
  }
}
</style>

